import React,{useEffect,useState} from 'react';
import io from 'socket.io-client';
import queryString from 'query-string';
import './Chat.css';
import InfoBar from '../InfoBar/InfoBar'
import Input from '../Input/Input'
import Messages from '../Messages/Messages'
import TextContainer from '../TextContainer/TextContainer'

let socket;
var connectionOptions =  {
    "force new connection" : true,
    "reconnectionAttempts": "Infinity", 
    "timeout" : 10000,                  
    "transports" : ["websocket"]
};

const Chat = () => {
    const[name,setName] = useState(null);
    const[room,setRoom] = useState(null);
    const[users,setUsers] = useState([]);
    const[message,setMessage] = useState(null);
    const[messages,setMessages] = useState([]);

    const ENDPOINT = 'https://node-react-chat-webapp.herokuapp.com/';

    useEffect(() => {
        var {name,room} = queryString.parse(window.location.search);
        socket = io.connect(ENDPOINT,connectionOptions);
        setName(name);
        setRoom(room);
        socket.emit('join',{name,room},() => {

        });
        return () => {
            socket.emit('disconnect');
            socket.off();
        }
    },[ENDPOINT]);

    useEffect(() => {
        socket.on('message',(message) => {
            setMessages([...messages,message]);
        })
    },[messages])

    useEffect(() => {
        socket.on('roomData',({users}) => {
            console.log("users:",users);
            setUsers(users);
        })
    },[users]);;

    const sendMessage = (event) => {
        event.preventDefault();
        if(message){
            socket.emit('sendMessage',message,() => setMessage(''));
        }
    }

    console.log(messages);

    return(
        <div className="outerContainer">
            <div className="container"> 
            <InfoBar room={room}/>
            <Messages messages={messages} name={name} />
            <Input message={message} setMessage={setMessage} sendMessage={sendMessage} />
            </div>
            <TextContainer users={users} room={room} />
        </div>
    )
};

export default Chat;